import config from '../../config/config';
import _ from 'lodash';

export const USER_UPDATE_FAILURE = 'USER_SETTINGS/USER_UPDATE_FAILURE';
export const USER_UPDATE_LOAD = 'USER_SETTINGS/USER_UPDATE_LOAD';
export const USER_UPDATE_SUCCESS = 'USER_SETTINGS/USER_UPDATE_SUCCESS';

export const TIMEZONE_UPDATE_FAILURE = 'USER_SETTINGS/TIMEZONE_UPDATE_FAILURE';
export const TIMEZONE_UPDATE_LOAD = 'USER_SETTINGS/TIMEZONE_UPDATE_LOAD';
export const TIMEZONE_UPDATE_SUCCESS = 'USER_SETTINGS/TIMEZONE_UPDATE_SUCCESS';
export const TIMEZONE_GET_FAILURE = 'USER_SETTINGS/TIMEZONE_GET_FAILURE';
export const TIMEZONE_GET_LOAD = 'USER_SETTINGS/TIMEZONE_GET_LOAD';
export const TIMEZONE_GET_SUCCESS = 'USER_SETTINGS/TIMEZONE_GET_SUCCESS';

export function updateUserFailureActionCreator(error) {
    return {
        error,
        type: USER_UPDATE_FAILURE
    };
}

export function updateUserSuccessActionCreator(user) {
    return {
        user,
        type: USER_UPDATE_SUCCESS
    };
}

export function updateUser(user = {}) {
    return {
        failureActionTypeOrCreator: updateUserFailureActionCreator,
        fetchParams: {
            url: `${config.userManagementApiUrl}/self`,
            method: 'put',
            body: user
        },
        loadActionTypeOrCreator: USER_UPDATE_LOAD,
        successActionTypeOrCreator: updateUserSuccessActionCreator
    };
}

export function updateTimezone(timezone) {
    return {
        failureActionTypeOrCreator: updateTimezoneFailureActionCreator,
        fetchParams: {
            url: config.userSettingsApiUrl,
            body: { Timezone: timezone },
            method: 'POST'
        },
        loadActionTypeOrCreator: TIMEZONE_UPDATE_LOAD,
        successActionTypeOrCreator: () => updateTimezoneSuccessActionCreator(timezone)
    };
}

export function updateTimezoneFailureActionCreator(error) {
    return {
        error,
        type: TIMEZONE_UPDATE_FAILURE
    };
}

export function updateTimezoneSuccessActionCreator(timezone) {
    return {
        timezone,
        type: TIMEZONE_UPDATE_SUCCESS
    };
}

export function fetchTimezone() {
    return {
        failureActionTypeOrCreator: getTimezoneFailureActionCreator,
        fetchParams: {
            url: `${config.userSettingsApiUrl}/Timezone`
        },
        loadActionTypeOrCreator: TIMEZONE_GET_LOAD,
        successActionTypeOrCreator: getTimezoneSuccessActionCreator
    };
}

export function getTimezoneFailureActionCreator(error) {
    return {
        error,
        type: TIMEZONE_GET_FAILURE
    };
}

export function getTimezoneSuccessActionCreator(event) {
    return {
        timezone: _.get(event, 'message') || 'UTC',
        type: TIMEZONE_GET_SUCCESS
    };
}
